import {ApplicationConfig, NgZone, Provider, provideZoneChangeDetection} from '@angular/core';
import {
  IApiEndpointService,
  INavigationService,
  PortalContext,
  portalContextFactory
} from "@de.fiduciagad.kundenportal/ui-context";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi
} from "@angular/common/http";
import {
  LocalizationInterceptor
} from "@de.fiduciagad.kundenportal/lib-interceptors";
import {TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader, TranslateHttpLoaderConfig} from "@ngx-translate/http-loader";
import {okpHttpInterceptorFn, provideOkpApi, withWebCompIntegration} from "@okp/ng-api";
import {provideTranslateService, TranslateLoader} from "@ngx-translate/core";
import {withNgZone} from "@okp/ng-api/ext/zone";
import {withKfTheme} from "@okp/ng-api/ext/kf-theme";
import {provideKfBaseSettings} from "@de.fiduciagad.kundenportal/kf-theme/common";

export function translateLoaderConfigFactory(portalContext: PortalContext): Partial<TranslateHttpLoaderConfig> {
  let assetUrl;
  const portalBasePath = (portalContext.getNavigationService() as INavigationService).getPortalBasePath();
  if (portalBasePath.includes('/bws')) {
    // Assets BWS
    const endpointService = portalContext.getApiEndpointService() as IApiEndpointService;
    assetUrl = endpointService.getServiceUrl('oekosystem-immosuche-ui', '/assets/i18n/');
    return {
      prefix: assetUrl,
      suffix: '.json',
    };
  } else if (portalBasePath === '/') {
    // Assets neue Homepage
    assetUrl = 'serviceproxy/oekosystem-immosuche-ui/assets/i18n/';
    const translationPath = `${portalBasePath}${assetUrl}`;
    return {
      prefix: translationPath,
      suffix: '.json',
    };
  } else {
    // Assets Online-Banking Kundensicht
    assetUrl = 'webcomponents/oekosystem-immosuche-ui/assets/i18n/';
    const translationPath = `${portalBasePath}${assetUrl}`;
    return {
      prefix: translationPath,
      suffix: '.json',
    };
  }
}

const provideNgZone = (): Provider => ({
  provide: NgZone,
  useValue: (window as any).ngZone,
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi(),withInterceptors([ okpHttpInterceptorFn ])),
    { provide: HTTP_INTERCEPTORS, useClass: LocalizationInterceptor, multi: true },
    provideOkpApi(withWebCompIntegration(), withKfTheme(), withNgZone()),
    provideZoneChangeDetection(),
    provideKfBaseSettings(),

    provideTranslateService({
      fallbackLang: 'de-DE',
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      }
    }),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useFactory: translateLoaderConfigFactory,
      deps: [PortalContext]
    },
    {
      provide: PortalContext,
      useFactory: portalContextFactory
    },
    provideNgZone()
  ]
};
